function initProductCardHover(container = document) {
  if (typeof gsap === 'undefined') {
    setTimeout(() => initProductCardHover(container), 100);
    return;
  }

  const productCards = container.querySelectorAll(".product-card-container");
  
  productCards.forEach((card) => {
    if (card.hasAttribute("data-gsap-hover")) return;
    
    const imageContainer = card.querySelector(".product-image-container");
    if (!imageContainer) return;
    
    const firstImage = imageContainer.querySelector(".main-image");
    const hoverImage = imageContainer.querySelector(".hover-image");

    if (!firstImage || !hoverImage) return;

    const hoverTL = gsap.timeline({ 
      paused: true,
      defaults: {
        duration: 0.8,
        ease: "power2.out",
      }
    });

    hoverTL
      .set(hoverImage, { 
        opacity: 0, 
        scale: 0.99,
        filter: "blur(2px)"
      })
      .set(firstImage, { 
        opacity: 1, 
        scale: 1,
        filter: "blur(0px)"
      })
      .to(firstImage, { 
        opacity: 0, 
        scale: 1.01,
        filter: "blur(2px)",
        duration: 0.8
      })
      .to(hoverImage, { 
        opacity: 1, 
        scale: 1,
        filter: "blur(0px)",
        duration: 0.8
      }, "<0.1");


    imageContainer.addEventListener("mouseenter", () => {
      if (window.innerWidth < 1024) return;
      hoverTL.timeScale(1).play();
    });

    imageContainer.addEventListener("mouseleave", () => {
      if (window.innerWidth < 1024) return;
      hoverTL.timeScale(1.5).reverse();
    });

    // Touch events for mobile
    imageContainer.addEventListener("touchstart", () => {
      if (window.innerWidth >= 1024) return;
      hoverTL.timeScale(1).play();
    });

    imageContainer.addEventListener("touchend", () => {
      if (window.innerWidth >= 1024) return;
      hoverTL.timeScale(1.5).reverse();
    });


    firstImage.classList.remove("lg:hover:opacity-0");
    hoverImage.classList.remove("peer-hover:opacity-100");
    
    card.setAttribute("data-gsap-hover", "true");
  });

}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCardHover);
} else {
  initProductCardHover();
}

function observeProductRecommendations() {
  const productRecommendations = document.querySelector('product-recommendations');
  if (productRecommendations) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setTimeout(() => {
            initProductCardHover(productRecommendations);
          }, 100);
        }
      });
    });

    observer.observe(productRecommendations, {
      childList: true,
      subtree: true
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeProductRecommendations);
} else {
  observeProductRecommendations();
}